<div class="p-8">
  <div class="w-100 flex items-center justify-between">
    <div class="flex flex-row items-center gap-2">
      <ion-icon class="alert-icon" icon="assets/icon/alert-blue-circle.svg"></ion-icon>
      <span class="alert-text barlow">¡Atención! Vas a rehacer tu pedido.</span>
    </div>
    <ion-icon class="close-icon cursor-pointer" icon="assets/icon/cross.svg" (click)="cancel()"></ion-icon>
  </div>
  <hr />
  <div class="flex flex-col items-start gap-5" *ngIf="!unavailable(); else unavailableTemp">
    <h1>¿Qué ocurre ahora?</h1>
    <p>
      A continuación el carrito se va a recuperar para que se puedan hacer modificaciones sobre él, no se perderán tus
      documentos. Se reembolsará el importe íntegro en el bono monedero como saldo disponible para rehacer el pedido.
    </p>
    <h1>¿Y sobre el importe abonado?</h1>
    <p>
      Al rehacer el pedido, el precio puede resultar inferior a la cantidad inicialmente abonada, por lo que el saldo
      sobrante quedará reflejado en tu cuenta y disponible en el bono monedero para que pueda usarse en sucesivos
      pedidos. Si por el contrario, tras la modificación del pedido resulta un precio superior, la diferencia deberá ser
      abonada seleccionando cualquiera de nuestros métodos de pago disponibles. 
    </p>

    <ion-checkbox mode="md" label-placement="end" [(ngModel)]="checked">
      <span class="check-text">Acepto las condiciones.</span>
    </ion-checkbox>
  </div>
  <ng-template #unavailableTemp>
    <div class="flex flex-col items-start gap-5">
      <p class="color-red">
        Lo sentimos, la opción de rehacer el pedido ya no está disponible porque éste ya ha sido procesado.
      </p>
    </div>
  </ng-template>
  <hr />
  <div class="w-100 flex flex-row justify-end gap-1">
    <ion-button color="medium-dark" fill="outline" (click)="cancel()">Cancelar</ion-button>
    <ion-button *ngIf="!unavailable()" [disabled]="!checked" (click)="submit()">Continuar</ion-button>
  </div>
</div>
